import { Flex } from '@urbaninfrastructure/react-ui-kit';

export default Flex;
